import { useId, useState } from 'react'

/**
 * A read-only field with a Copy button, for the one-time token panel. Kept
 * local to this feature rather than imported from another feature's own
 * component tree, so a change there can never break this Settings page.
 */
export function CopyField({ label, value }: { label: string; value: string }) {
  const [copied, setCopied] = useState(false)
  const [copyFailed, setCopyFailed] = useState(false)
  const canCopy = typeof navigator !== 'undefined' && Boolean(navigator.clipboard)
  const id = useId()

  return (
    <div className="ci-websites__copy">
      <label htmlFor={id}>{label}</label>
      <span className="ci-websites__copy-row">
        <input id={id} readOnly value={value} onFocus={(event) => event.currentTarget.select()} />
        {canCopy ? (
          <button
            type="button"
            className="ci-button"
            aria-label={`Copy ${label.toLowerCase()}`}
            onClick={() => {
              navigator.clipboard
                .writeText(value)
                .then(() => {
                  setCopied(true)
                  setCopyFailed(false)
                })
                .catch(() => setCopyFailed(true))
            }}
          >
            {copied ? 'Copied' : 'Copy'}
          </button>
        ) : null}
      </span>
      {copyFailed ? (
        <p role="alert" className="ci-websites__copy-error">
          Copying failed — select the value above and copy it yourself before leaving this page.
        </p>
      ) : null}
    </div>
  )
}
